'use client';

import { ButtonLink } from '@/components/atoms/Button';
import { useSplitAndHeap } from '@/hooks/useSplitAndHeap';
import cn from 'classnames';
import type { Variant } from '@/components/atoms/Button/button.d';

interface ReplaceFootprintButtonProps {
	testId?: string;
	className?: string;
	variant?: Variant;
}

const ReplaceFootprintButton = (props: ReplaceFootprintButtonProps) => {
	const {
		testId = 'ReplaceFootprintButton',
		variant = 'large-primary-gradient',
		className,
	} = props;

	const { ReplaceFootprint } = useSplitAndHeap('ReplaceFootprint');
	const { treatment } = ReplaceFootprint;
	const replaceFlowHref =
		treatment === 'on' ? '/replace/get-started/' : '/replace/in-person/';

	return (
		<ButtonLink
			data={{ testId: testId }}
			href={replaceFlowHref}
			variant={variant}
			className={cn(className)}
		>
			Get a new system
		</ButtonLink>
	);
};

export default ReplaceFootprintButton;
